<div class="document-list-item" [ngClass]="{'selected': viewModel.selected}">
  <sc-flex >
    <div class="document-title">
      {{viewModel.title}}
    </div>
    @if (viewModel.selected && allowAdd) {
      <div class="remove-document-btn">
        <sc-icon iconClass="fa-times close-btn" (click)="deleteDocument(viewModel)"></sc-icon>
      </div>
    }
  </sc-flex>
</div>